import { DownloadIcon } from '@chakra-ui/icons';
import { Button } from '@chakra-ui/react';
import { useState } from 'react';
import { CSVLink } from 'react-csv';

import { buildCohortRevenueBreakdownCsvPayload } from './buildCohortRevenueBreakdownCsv';

const CohortBreakdownCsv = ({
  cohortRevenueBreakdown,
  modelResults,
  resolveDownloadFilename,
}) => {
  const [csvData, setCsvData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [downloadFilename, setDownloadFilename] = useState(
    'cohort-revenue-breakdown.csv'
  );

  const generateCsvData = () => {
    if (resolveDownloadFilename) {
      setDownloadFilename(resolveDownloadFilename('cohort-revenue-breakdown'));
    }

    const payload = buildCohortRevenueBreakdownCsvPayload({
      cohort_revenue_breakdown: cohortRevenueBreakdown,
      items: modelResults,
    });
    if (!payload) {
      setCsvData([]);
      setHeaders([]);
      return;
    }
    setHeaders(payload.headers);
    setCsvData(payload.data);
  };

  return (
    <Button variant={'outline'} leftIcon={<DownloadIcon />}>
      <CSVLink
        data={csvData}
        headers={headers}
        filename={downloadFilename}
        onClick={generateCsvData}
        asyncOnClick={true}
      >
        Cohort Breakdown
      </CSVLink>
    </Button>
  );
};

export default CohortBreakdownCsv;
